import { useEffect, useState } from "react";
import { Sidebar } from "../Sidebar/Sidebar";

import "./Layout.scss";

interface Props {
  children: JSX.Element;
}

const isStaging = process.env.REACT_APP_API_BASE_URL?.includes("stage.");
const API_BASE = process.env.REACT_APP_API_BASE_URL ?? "";

export const Layout = ({ children }: Props): JSX.Element => {
  const [database, setDatabase] = useState<string | null>(null);

  useEffect(() => {
    if (!isStaging) return;
    fetch(`${API_BASE}api/v1/environment`)
      .then((r) => r.json())
      .then((data) => setDatabase(data.database))
      .catch(() => null);
  }, []);

  return (
    <div className="page">
      {isStaging && (
        <div className="staging-banner">
          STAGING{database ? ` — db: ${database}` : ""}
        </div>
      )}
      <div className="page__sidebar">
        <Sidebar />
      </div>
      <div
        id="page__content"
        className="page__content">
        {children}
      </div>
    </div>
  );
};
